<div class="patient-modal">
    <div class="modal-dialog patient-modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">Informations bénéficiaire</h2>
            </div>
            <div class="modal-body">
                <div class="row patient-row patient-name">
                    <div class="col-md-6"><label>Nom :</label><span>{{ordonnance.nom}}</span></div>
                    <div class="col-md-6"><label>Prénom :</label><span>{{ordonnance.prenom}}</span></div>
                </div>
                <div class="row patient-row patient-medecin">
                    <div class="col-md-12"><label>Médecin Traitant :</label><span>{{ordonnance.nomMedecin}}</span></div>
                </div>
                <div class="row patient-row patient-tel">
                    <div class="col-md-12"><label>Téléphone :</label><span>{{ordonnance.tel}}</span></div>
                </div>
              <div *ngIf="ordonnance.emailPatient != null" class="row patient-row patient-email">
                <div class="col-md-12"><label>E-mail :</label><span>{{ordonnance.emailPatient}}</span></div>
              </div>
                <div class="row patient-row patient-comment">
                    <div class="col-md-12">
                        <label>Commentaire associé à l'ordonnance :</label>
                        <textarea readonly="readonly" style="width:400px; height:70px">{{ordonnance.commentaire}}</textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger btn-giphar" (click)="closeModal()">Fermer</button>
              <button type="button" class="btn btn-info btn-rejetee" (click)="afficherModalSMS()" disabled>Envoyer un SMS au client</button>
            </div>
        </div>
    </div>
</div>

<app-sms-client
  *ngIf="afficherEnvoieSMS"
  (modalSMS)="changeAfficherModalSMS($event)">
</app-sms-client>

